// extracted by mini-css-extract-plugin
module.exports = {"Order":"Order_Order__3dA2L"};